import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// MALWEST design — New-customers campaign (adc_qe9ysxkkwq). RUNNING since
// 2025-01-18. Real lifetime aggregates from
// ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS (complete months
// Jan 2025 – Jul 2026). Monthly series lives in realBrandData.ts.
export const campMwNew: FaireAdCampaignEntity = {
  token: "camp_mw_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_malwest",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 1800,
  startedRunningAt: "2025-01-18",
  segmentMetrics: {
    numCustomersAcquired: 19,
    salesDollars: 6564,
    totalAdsSpendDollars: 2934,
    cpaDollars: 154,
    bestEstimateSalesDollars: 6694,
    bestEstimateRoas: 2.28,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-10T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
